import React from 'react';
import { useParams } from 'react-router';

import Spinner from '@/src/components/common/Elements/Spinner/Spinner';

import UpdateFileStatus, {
  FileEntryUpdateFileStatus,
} from '../../../../FileEntryViewer/components/UpdateFileStatus/UpdateFileStatus';
import { useUpdateEmailFileStatus } from '../api/updateEmailFileStatus';

type UpdateFileStatusProps = {
  fileEntry: FileEntryUpdateFileStatus;
  inboxEntryId: number;
  emailId: number;
};

const UpdateEmailFileStatus = ({ fileEntry, inboxEntryId, emailId }: UpdateFileStatusProps) => {
  const { projectId } = useParams<{ projectId: string }>();
  const updateStatusMutation = useUpdateEmailFileStatus({
    projectId,
    emailId,
    inboxEntryId,
    fileId: fileEntry.id,
  });
  return (
    <React.Fragment>
      {updateStatusMutation.isLoading && <Spinner />}
      <UpdateFileStatus fileEntry={fileEntry} updateStatusMutation={updateStatusMutation} />
    </React.Fragment>
  );
};

export default UpdateEmailFileStatus;
